import { fromJS, merge } from 'immutable';
import { FluxStandardAction } from '__utils/type';
import * as Actions from 'constants/actions'

export interface mandateState {

    userMandatesList: any;
    fetchUserMandateListFailure?: unknown;
    mandateActivateConfig: any;
}
const rawState: mandateState = {
    userMandatesList: [],
    mandateActivateConfig: {}
};

const intialState = fromJS(rawState);

export default function userMandateReducer(
    state = intialState,
    action: FluxStandardAction
) {
    switch (action.type) {
        case Actions.SET_MANDATE_ACTIVATE_CONFIG:
            return merge(state, fromJS({ mandateActivateConfig: action.payload }));

        case Actions.FETCH_GET_USER_MANDATES_LIST_SUCCESS:
            return merge(state, fromJS({ userMandatesList: action.payload }));

        case Actions.FETCH_GET_USER_MANDATES_LIST_FAILURE:
            return merge(state, fromJS({ fetchUserMandateListFailure: action.payload, userMandatesList: null }));
        default:
            return state;
    }
}
